export default "__VITE_ASSET__CNNlXoQA__"